import { Component, OnInit } from "@angular/core";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";

import { SharedService } from "@shared/services/shared.service";
import { AdminService } from "app/services/admin/admin.service";
import { BusinessService } from "app/services/business/business.service";
import { IBusinessView } from "app/models/business/business";
import { GotoComplaintComponent } from "./gotoComplaint/gotoComplaint.component";
import { Subscription } from "rxjs";


@Component({
  selector: 'business',
  templateUrl: './business.component.html'
})

export class BusinessComponent implements OnInit {

  businessSubscription: Subscription;
  complaintCount: number = 0;
  commentCount: number = 0;
  businessId: number = 0;
  currentTab: number = 0;
  showInspection: boolean = true;

  constructor(
    private sharedService: SharedService,
    private adminService: AdminService,
    private businessService: BusinessService,
    private modalService: MatDialog,
  ) {

  }

  ngOnInit(): void {
    this.businessSubscription = this.businessService.updateBusinessEvent.subscribe((data: number) => { 
      let list = this.businessService.currentBusiness ? this.businessService.currentBusiness : {} as IBusinessView;

      this.showInspection = list.exempt && +list.exemptTypeId > 1 ;
      this.complaintCount = list.complaints ? list.complaints.length : 0;
      this.commentCount = list.comments ? list.comments.length : 0;
    });
    this.currentTab = this.businessService.businessTab;
  }

  ngOnDestroy() {
    this.businessSubscription.unsubscribe();
  }
 
  complaintView() {
    this.adminService.currentBusiness = null;

    let config = new MatDialogConfig<any>();
    config.autoFocus = true;
    config.disableClose = false;
    config.minWidth = 800;
    config.maxHeight = 600;
    config.data = { };
    const dialogRef = this.modalService.open(GotoComplaintComponent, config);
    dialogRef.afterClosed().subscribe(
      data => {
      },
      error => console.log('error: ', error),
      () => { }
    );   
  }

  tab() {
    this.businessService.updateTabs(this.currentTab);
  }

}